import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import ReactDOM from 'react-dom/client'
import App from './App'

if (process.env.REACT_APP_DD_RUM_ENABLED === 'true') {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_RUM_APP_ID ?? '',
    clientToken: process.env.REACT_APP_DD_RUM_CLIENT_TOKEN ?? '',
    site: 'datadoghq.com',
    service: 'delco-portal',
    env: process.env.REACT_APP_DD_ENV ?? 'production',
    version: process.env.REACT_APP_VERSION ?? '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      { match: (url: string) => { const apiUrl = process.env.REACT_APP_API_URL; return apiUrl ? url.startsWith(apiUrl) : false }, propagatorTypes: ['datadog'] }
    ],
    plugins: [reactPlugin({ router: false })]
  })
  datadogRum.startSessionReplayRecording()
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(<App />)
